import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FORGOT_PASSWORD_ROUTES } from './forgot-password.routes';

@NgModule({
  imports: [RouterModule.forChild(FORGOT_PASSWORD_ROUTES)],
  exports: [RouterModule],
  providers: []
})
export class ForgorPasswordRoutesModule {}
